
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box, Card, IconButton, Grid, Tooltip, Typography, CardContent } from '@mui/material';
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const CardMediaStyle = styled('div')({
  position: 'relative',
  paddingTop: 'calc(100% * 3 / 4)',
});

const TitleStyle = styled(Typography)({
  height: 44,
  overflow: 'hidden',
  WebkitLineClamp: 2,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
});

const InfoStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(3),
  color: theme.palette.text.disabled,
}));

const CoverImgStyle = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

const actionsSx = {
  '& .MuiIconButton-root': {
    width: 36,
    height: 36,
    '&:hover': {
      backgroundColor: 'rgba(3, 44, 101, 0.08)',
    },
  },
};

// ----------------------------------------------------------------------

CarrouselCard.propTypes = {
  carrousel: PropTypes.shape({
    date: PropTypes.any,
    hashid: PropTypes.any,
    body: PropTypes.any,
    picture: PropTypes.any,
    comment: PropTypes.any,
    title: PropTypes.any,
  }).isRequired,
  onDelete: PropTypes.func,
};

export default function CarrouselCard({ carrousel, onDelete }) {
  const navigate = useNavigate();
  const { hashid, body, picture, title } = carrousel;
  const latestEventLarge = false;
  const latestEvent = false;

  return (
    <Grid item xs={12} sm={latestEventLarge ? 12 : 6} md={latestEventLarge ? 6 : 3}>
      <Card sx={{ position: 'relative' }}>
        <CardMediaStyle
          sx={{
            ...((latestEventLarge || latestEvent) && {
              pt: 'calc(100% * 4 / 3)',
              '&:after': {
                top: 0,
                content: "''",
                width: '100%',
                height: '100%',
                position: 'absolute',
                backgroundColor: 'rgba(33, 33, 33, 0.72)',
              },
            }),
            ...(latestEventLarge && {
              pt: {
                xs: 'calc(100% * 4 / 3)',
                sm: 'calc(100% * 3 / 4.66)',
              },
            }),
          }}
        >
          <CoverImgStyle alt={title} src={picture} />
        </CardMediaStyle>

        <CardContent
          sx={{
            pt: 4,
            ...((latestEventLarge || latestEvent) && {
              bottom: 0,
              width: '100%',
              position: 'absolute',
            }),
          }}
        >
          <Typography gutterBottom variant="caption" sx={{ color: 'text.disabled', display: 'block' }}>
            {body}
          </Typography>

          <TitleStyle
            variant="subtitle2"
            sx={{
              ...(latestEventLarge && { typography: 'h5', height: 60 }),
              ...((latestEventLarge || latestEvent) && {
                color: 'common.white',
              }),
            }}
          >
            {title}
          </TitleStyle>

          <InfoStyle sx={actionsSx}>
            <Tooltip title="Editar">
              <IconButton onClick={() => navigate(`/dashboard/carrousel/edit/${hashid}`)}>
                <Iconify icon="eva:edit-fill" sx={{ width: 24, height: 24, color: '#032C65' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Ver">
              <IconButton onClick={() => navigate(`/dashboard/carrousel/view/${hashid}`)}>
                <Iconify icon="eva:eye-fill" sx={{ width: 24, height: 24, color: '#6d8ee9' }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar">
              <IconButton onClick={() => onDelete(hashid)}>
                <Iconify icon="eva:trash-2-outline" sx={{ width: 24, height: 24, color: '#FF003F' }} />
              </IconButton>
            </Tooltip>
          </InfoStyle>
        </CardContent>
      </Card>
    </Grid>
  );
}
